import { DropdownSize } from './types';

type StyleClassesType = {
  button: {
    size: Record<DropdownSize, string>;
  };
  list: {
    size: Record<DropdownSize, string>;
  };
  listItem: {
    size: Record<DropdownSize, string>;
  };
  leftIcon: {
    size: Record<DropdownSize, string>;
  };
  rightIcon: {
    size: Record<DropdownSize, string>;
  };
};

export const dropdownClasses: StyleClassesType = {
  button: {
    size: {
      'extra-small': 'pl-3 pr-8 py-1 text-xs rounded-3xl',
      small: 'pl-3 pr-8 py-2 text-sm leading-4 rounded-md',
      base: 'pl-4 pr-8 py-2 text-sm rounded-md',
      large: 'px-4 pr-8 py-2 text-base rounded-md',
      'extra-large': 'px-6 pr-8 py-3 text-base rounded-md',
    },
  },
  list: {
    size: {
      'extra-small': 'rounded-lg',
      small: 'rounded-md',
      base: 'rounded-md',
      large: 'rounded-md',
      'extra-large': 'rounded-md',
    },
  },
  listItem: {
    size: {
      'extra-small': 'pl-3 pr-4 py-1.5 text-xs',
      small: 'pl-3 pr-4 py-2 text-sm',
      base: 'pl-3 pr-4 py-2 text-sm',
      large: 'pl-3 pr-4 py-2 text-base',
      'extra-large': 'pl-3 pr-4 py-2 text-base',
    },
  },
  leftIcon: {
    size: {
      'extra-small': '-ml-0.5 mr-2 h-4 w-4',
      small: '-ml-0.5 mr-2 h-4 w-4',
      base: '-ml-1 mr-2 h-5 w-5',
      large: '-ml-1 mr-3 h-5 w-5',
      'extra-large': '-ml-1 mr-3 h-5 w-5',
    },
  },
  rightIcon: {
    size: {
      'extra-small': 'ml-2 h-4 w-4',
      small: 'ml-2 h-4 w-4',
      base: 'ml-2 h-5 w-5',
      large: 'ml-3 h-5 w-5',
      'extra-large': 'ml-3 h-5 w-5',
    },
  },
};
